import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DsTimelineItem } from '@inyova/models';

@Component({
  selector: 'app-ds-timeline',
  templateUrl: './ds-timeline.component.html',
  styleUrls: ['./ds-timeline.component.scss'],
  standalone: false
})
export class DsTimelineComponent {
  @Input() items: DsTimelineItem[];
  @Input() header: string;
  @Input() language: string;
  @Input() markAllAsSeenText: string;
  @Input() showHeader = true;
  @Input() showMarkAsSeen = true;
  @Output() markAsSeen: EventEmitter<string | number> = new EventEmitter<string | number>();
  @Output() markAllAsSeen: EventEmitter<void> = new EventEmitter<void>();

  getTimelineIcon(type: string) {
    switch (type) {
      case 'letter':
        return 'mail';
      case 'telephone':
        return 'phone-call';
      case 'talk':
        return 'speech';
      case 'divestment':
        return 'hand-coins';
      case 'collaboration':
        return 'users-round';
      case 'media_event':
        return 'megaphone';
      case 'resolution':
        return 'file-text';
      case 'candidate':
        return 'user-round';
      case 'other':
        return 'ellipsis';
      default:
        return 'file-text';
    }
  }

  getFormatedDate(date: string) {
    return new Intl.DateTimeFormat(this.language, { month: 'long', year: 'numeric' }).format(new Date(date));
  }

  onMarkAsSeen(id: string | number) {
    this.markAsSeen.emit(id);
  }

  onMarkAllAsSeen() {
    this.markAllAsSeen.emit();
  }
}
